import styled from 'styled-components';

import { RectangleSkeleton, TextSkeleton, TitleSkeleton } from '@treezor/design-system';

const DescriptionContainer = styled.div`
  margin: 1rem 0 4rem 0;
  > span {
    &.MuiSkeleton-root {
      margin: 0.3rem 0rem;
    }
  }
`;

const ButtonSkeleton = styled(RectangleSkeleton)`
  float: right;
  &.MuiSkeleton-root {
    border-radius: 2rem;
    margin-top: 0rem;
  }
`;

export const ConfigCommonSkeleton = () => (
  <>
    <ButtonSkeleton width="18rem" height="2rem" />
    <TextSkeleton width="7%" />
    <DescriptionContainer>
      <TitleSkeleton width="35%" />
      <TitleSkeleton width="22%" />
    </DescriptionContainer>
  </>
);
